import React from 'react'
import { Message } from '../locale/Message'

class Footer extends React.Component {

  render() {
    const { lang } = this.props
    return (
      <footer
        className="main-footer bg-purple text-white d-flex align-items-center d-xl-block px-3">
        <ul className="d-none d-xl-flex align-items-xl-center justify-content-xl-center">
          <li className="list-unstyled">
            <a href={`https://b2b.kcell.kz/${lang}/article/217/528`}>
              {Message.paymentTerms[lang]}
            </a>
          </li>
          <li className="list-unstyled">
            <a href={`https://b2b.kcell.kz/${lang}/b2b.account/eregistry/2369`}>
              {Message.eRegister[lang]}
            </a>
          </li>
          <li className="list-unstyled">
            <a href={`https://b2b.kcell.kz/${lang}/article/2585/527`}>
              {Message.applicationSamples[lang]}
            </a>
          </li>
          <li className="list-unstyled">
            <a href={`https://www.kcell.kz/${lang}/contacts/phones`}>
              {Message.contacts[lang]}
            </a>
          </li>
        </ul>
        <p className="copyright text-center t-regular">
          {Message.footerText[lang]}
        </p>
      </footer>
    )
  }

}

export default Footer